import { style } from '@vanilla-extract/css';

export const popoverPanel = style(
  {
    border: 'none',
    maxHeight: 'inherit',
    maxWidth: 'inherit',
  },
  'segment-popover-panel',
);

export const popoverConditions = style(
  {
    maxHeight: '230px',
    overflow: 'auto',
  },
  'segment-popover-conditions',
);

export const popoverMinWidth = style(
  {
    minWidth: '400px',
  },
  'segment-popover-min-width',
);
